import { useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import DateSelect from "../XoSoSidebar/DateSelect";
import useDienToan123 from "../DienToan123/useDienToan123";
import { PRODUCT, TZ } from "../DienToan123/constants";
import CompactResult from "./CompactResult";
import "../XoSoSidebar/XoSoSidebar.css";
import "./SidebarDienToan123.css";

dayjs.extend(utc);
dayjs.extend(timezone);

function SidebarDienToan123({ defaultDate, dataDefault, config }) {
  const today = dayjs().tz(TZ).format("YYYY-MM-DD");
  const [date, setDate] = useState(defaultDate || dataDefault || config?.date || null);
  const { results, loading, resolvedDate } = useDienToan123(date, 1);
  const selectedDate = date || resolvedDate || today;

  return (
    <div className="xoso-sidebar dt123-sidebar">
      <div className="xoso-sidebar__head">
        <div className="xoso-sidebar__title">
          KQXS <span>{PRODUCT}</span>
        </div>
        <DateSelect value={selectedDate} onChange={setDate} maxDate={today} />
      </div>
      <CompactResult result={results[0]} date={selectedDate} loading={loading} />
    </div>
  );
}

SidebarDienToan123.DateSelect = DateSelect;
SidebarDienToan123.Result = CompactResult;

export { DateSelect, CompactResult };
export default SidebarDienToan123;
